<template>
  <b-modal
    v-model="visible"
    title="Chuyển cửa hàng tiếp nhận bảo hành"
    class="warranty-change-store-modal"
    @show="onShow"
    @hidden="onHidden"
  >
    <template v-if="warranty">
      <b-row class="align-items-center mb-3">
        <b-col>
          <div class="d-flex align-items-center flex-wrap">
            <span class="text-muted mr-2">Cửa hàng hiện tại:</span>
            <strong class="mr-2">{{ warranty.storeName }}</strong>
            <i class="fas fa-arrow-right text-primary mr-2"></i>
            <span class="text-muted mr-1">Sang:</span>
            <strong v-if="selectedStoreLabel">{{ selectedStoreLabel }}</strong>
            <span
              v-else
              class="text-muted"
              >Chưa chọn</span
            >
          </div>
        </b-col>
      </b-row>

      <b-form-group
        label="Chọn 1 cửa hàng muốn chuyển đến"
        label-class="required-label"
      >
        <Autosuggest
          :model.sync="searchStore"
          :suggestions="storeSuggestions"
          placeholder="cửa hàng"
          suggestion-name="suggestionName"
          :limit="10"
          @change="onStoreInputChange"
          @select="onStoreSelected"
        >
          <template
            slot="custom"
            slot-scope="{ suggestion }"
          >
            <div class="d-flex align-items-center">
              {{ suggestion.item.suggestionName }}
            </div>
          </template>
        </Autosuggest>
      </b-form-group>
    </template>
    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        @click="hide"
        >Hủy</b-button
      >
      <SaveButton
        :is-busy="busy"
        :disabled="!selectedStoreId"
        @click="onSave"
      />
    </template>
  </b-modal>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
import SaveButton from '@/view/components/common/SaveButton.vue'

export default {
  name: 'WarrantyChangeStoreModal',
  components: {
    Autosuggest,
    SaveButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    warranty: {
      type: Object,
      default: null,
    },
    optionStores: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedStoreId: null,
      searchStore: '',
      storeSuggestions: [],
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    storeOptions() {
      if (!this.warranty || !this.optionStores.length) return this.optionStores
      const currentId = this.warranty.storeId
      return this.optionStores
        .filter((s) => s.id !== currentId)
        .map((s) => ({
          ...s,
          suggestionName:
            s.name && s.label && s.name !== s.label
              ? `${s.name} (${s.label})`
              : s.label || s.name || '',
        }))
    },
    selectedStoreLabel() {
      if (!this.selectedStoreId || !this.storeOptions.length) return ''
      const found = this.storeOptions.find((s) => s.id === this.selectedStoreId)
      return found ? found.label || found.name : ''
    },
  },
  methods: {
    onShow() {
      this.selectedStoreId = null
      this.searchStore = ''
      this.storeSuggestions = this.storeOptions.slice(0, 10)
    },
    onStoreSelected(option) {
      const item = option?.item
      if (!item) return
      this.selectedStoreId = item.id
      this.searchStore = item.suggestionName || item.label || item.shortName || ''
    },
    onStoreInputChange(text) {
      this.searchStore = text || ''
      const q = (text || '').trim().toLowerCase()
      if (!q) {
        this.selectedStoreId = null
        this.storeSuggestions = this.storeOptions.slice(0, 10)
        return
      }
      const filtered = this.storeOptions.filter(
        (s) =>
          (s.label && s.label.toLowerCase().includes(q)) ||
          (s.shortName && s.shortName.toLowerCase().includes(q)),
      )
      this.storeSuggestions = filtered.slice(0, 10)
    },
    onHidden() {
      this.$emit('hidden')
    },
    hide() {
      this.visible = false
    },
    onSave() {
      if (!this.selectedStoreId || !this.warranty?.id || this.busy) return
      this.$emit('save', {
        warrantyId: this.warranty.id,
        storeId: this.selectedStoreId,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.required-label::after {
  content: ' *';
  color: #f64e60;
}
</style>
